import { useTranslation } from 'react-i18next'

import { PackageIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import SummaryLineItem from '../SummaryLineItem/SummaryLineItem'
import * as Styles from './styles'

const CurrentShipment = ({ lineItems }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Styles.TitleContainer>
        <PackageIcon size={24} weight="light" />
        <Text type="titleS">{t('Envío actual')}</Text>
      </Styles.TitleContainer>
      {lineItems?.length > 0 ? (
        lineItems.map(item => <SummaryLineItem key={item.id} item={item} />)
      ) : (
        <Text type="bodyMRegular" color={theme.colors.text.subtle}>
          {t('Sin productos')}
        </Text>
      )}
    </Styles.Container>
  )
}

export default CurrentShipment
